import { CarregaService } from '../services/carrega_file/carrega.service';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { format, parse, differenceInDays } from 'date-fns';
import { ApiService } from '../services/contratos/contratos.service';
import { map, take } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';



@Component({
  selector: 'atualizar-root',
  templateUrl: './atualizar.component.html',
  styleUrls: ['./atualizar.component.css'],
  template: `
    <progressbar [value]="progressValue" [max]="100">{{ progressValue }}%</progressbar>
  `,
  standalone: false
})
export class AtualizarComponent {
  progressValue = 0; // Valor atual da barra de progresso
  maxValue = 0; // Valor máximo da barra de progresso
  showProgressBar = false;
  @ViewChild('downloadLink') downloadLink!: ElementRef<HTMLAnchorElement>;
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'items_Excel_Karrara';
  items$: Observable<any> | undefined;
  dataLoaded = false;
  jsonData: any;
  sortColumn: string = '';
  sortDirection: number = 1;
  dias_terminal: Date = new Date();
  Freetime: number = 0;
  dados: any[] = [];
  contratos: string[] = [];
  freetime: string[] = [];
  tripcost: string[] = [];
  custoViagem: string = "";
  handling: string[] = [];
  manuseio: string = "";
  demurrage: string[] = [];
  estadia: string = "";
  valorFree: string = '';
  liner: string = "";
  vessel: string = "";
  custoestadia: number = 0;
  isLoading: boolean = true;
  query3: string = 'tipos_Veiculos_Karrara';
  urlConsultaCompleta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  veiculos!: any[];


  constructor(
    private carregaService: CarregaService,
    private http: HttpClient,
    private dynamodbService: ApiService,


  ) { }

  async onFileSelected(event: any) {
    const file: File = event.target.files[0];
    const fileUrl = URL.createObjectURL(file);
    const fileBlob = await fetch(fileUrl).then(response => response.blob());
    const rawData = await this.carregaService.loadFile(fileBlob);
    const inflatedData = await this.inflateData(rawData); // Inflar os campos desejados
    this.jsonData = inflatedData;
    this.dataLoaded = true;
    // //console.log("jsonData")
    // //console.log(this.jsonData)    
    // Chama a função para salvar os dados no API Gateway
  }

  isValorValido(value: any): boolean {
    return value != '' && value != null && value != undefined && value != 0;
  }

  async salvarNoBanco(jsonData: any) {
    const currentDate = new Date().getTime();
    // const year = currentDate.getFullYear();
    // const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    // const day = currentDate.getDate().toString().padStart(2, '0');
    // const hours = currentDate.getHours().toString().padStart(2, '0');
    // const minutes = currentDate.getMinutes().toString().padStart(2, '0');
    // const seconds = currentDate.getSeconds().toString().padStart(2, '0');
    // // Formata a data e hora no formato ISO desejado (sem considerar o fuso horário)
    // const isoDateString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.000Z`;
    // this.isLoading = true;
    this.showProgressBar = true;
    //console.log('Item a ser salvo:', jsonData);
    this.progressValue = 0;
    this.maxValue = jsonData.length;
    const batchSize = 10; // Defina o tamanho máximo para cada lote
    const batches = this.chunkArray(jsonData, batchSize); // Fraciona o jsonData em lotes menores
    // //console.log(this.veiculos)
    this.jsonData.forEach((item: any) => {
      // //console.log(this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']))
      // //console.log(item['Transport Type'])
      // //console.log(item['Transport Type'])
      item.created = currentDate.toString();
      item.capacidadePeso = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).peso : 0,
        item.capacidadeVolumetrica = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).volume : 0,
        item.veiculoPerfil = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).perfil : 'Não encontrado',
        item.emissao = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).emissoes : 0,
        item.consumo = this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']) ? this.veiculos.find(veiculo => veiculo.modelo == item['Transport Type']).consumo : 0
    })

    this.jsonData.forEach((item: any) => {
      item.emissaoTotal = (item['Total Distance'] * item.emissao) / item.consumo;
      item.pesoLoaded = this.isValorValido(item['Weight Loaded']) ? ((item['Weight Loaded'] / item.capacidadePeso) * 100) : 0;
      item.cub = this.isValorValido(item.Cubage) ? ((item.Cubage / item.capacidadeVolumetrica) * 100) : 0;
      item.fillingRateMax = Math.max(item.pesoLoaded, item.cub)
    })

    // console.log(jsonData)

    for (const batch of batches) {
      // Acrescentar o campo "lastupdate" com o valor da data de hoje
      const currentDate = new Date();
      const formattedDate = currentDate.getDate().toString().padStart(2, '0') +
        (currentDate.getMonth() + 1).toString().padStart(2, '0') +
        currentDate.getFullYear().toString();
      for (const item of batch) {
        item.lastupdate = formattedDate;
        console.log(item)
      }

      await this.dynamodbService.salvar(batch, this.query, this.urlAtualiza).subscribe(
        response => {
          this.progressValue = this.progressValue + batch.length;
          // //console.log('Resposta do salvamento:', response);
          this.showProgressBar = false;
          this.isLoading = false;
        },
        error => {
          console.error('Erro ao salvar:', error);
        }
      );
    }
  }


  chunkArray(array: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  }

  async ngOnInit() {
    await this.getVeiculosFromDynamoDB();
    const key = 'liner'; // Substitua 'propriedade' pelo nome da propriedade que você deseja obter
    const query = 'PowerMathDatabase2'
    const filtro = '';
    this.items$ = (await this.dynamodbService.getItems(query, this.urlConsulta, filtro)).pipe(
      map(data => {
        const parsedData = JSON.parse(data.body); // Parse a string JSON contida em data.body
        return parsedData; // Retorna o objeto JSON parseado
      })
    );


    this.items$.subscribe(
      items => {
        this.contratos = items.map((item: { liner: any; }) => item.liner);
        this.freetime = items.map((item: { freetime: any; }) => item.freetime);
        this.tripcost = items.map((item: { tripcost: any; }) => item.tripcost);
        this.handling = items.map((item: { fsperiod: any; }) => item.fsperiod);
        this.demurrage = items.map((item: { scperiod: any; }) => item.scperiod);

      },
      error => {
        console.error(error);
      }
    );
    this.isLoading = false;
  }



  testarArquivo(arquivo: File): void {
    this.carregaService.testarArquivoCSV(arquivo).then((estaCorreto) => {
      if (estaCorreto) {
        //console.log('O arquivo CSV está correto.');
      } else {
        //console.log('O arquivo CSV está incorreto.');
      }
    }).catch((erro) => {
      console.error('Erro ao testar o arquivo CSV:', erro);
    });
  }

  excelDateToJsDate(excelDateNumber: number): Date {
    // //console.log("data entrada funcao")
    // //console.log(excelDateNumber)
    const jsDate = new Date((excelDateNumber - 1) * 24 * 60 * 60 * 1000 + Date.UTC(1900, 0, 1));
    // //console.log("data saida funcao")
    // //console.log(jsDate)
    return jsDate;
  }

  inflateData(rawData: any[]): any[] {

    let i = 0;
    return rawData.map((item: any) => {

      const janelas: string[] = item['5'].split('|'); // Divide o valor da chave '5' usando o caractere '|'
      const janelaData: Date[] = [];
      const fornecedor: string[] = item['6'].split('|'); // Divide o valor da chave '6' usando o caractere '|'
      const destino: string[] = item['15'].split('|'); // Divide o valor da chave '6' usando o caractere '|'
      const janelaDestinoData: Date[] = [];
      const janeladestino: string[] = item['17'].split('|'); // Divide o valor da chave '6' usando o caractere '|'
      const currentDate = new Date();
      // const formattedDate = format(currentDate, 'ddMMyyyyHHmmss') + i;
      i = i + 1;
      // //console.log(formattedDate);
      // const serialNumber = item['4'];
      // const dataFormatada = this.carregaService.formatDate(serialNumber);
      // const dataDestinoFormatada = this.carregaService.formatDate(item['16']);
      let passos = 0;

      /********* */

      // const datesString: string = item['4'];
      var dataColeta: string = item['4'] as string;
      var dataDestino: string = item['16'] as string;


      if (typeof dataColeta !== 'string') {
        const jsDate = this.excelDateToJsDate(dataColeta);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;
        dataColeta = formattedDate
      }


      if (typeof dataColeta === 'string') {
        const dateStrings: string[] = dataColeta.includes('|') ? dataColeta.split('|') : [dataColeta];
        const dates: Date[] = [];
        // console.log(dateStrings)
        for (const dateString of dateStrings) {
          const parts: string[] = dateString.split('/');
          if (parts.length === 3) {
            const day: number = parseInt(parts[0], 10);
            const month: number = parseInt(parts[1], 10);
            const year: number = parseInt(parts[2], 10);
            const date: Date = new Date(year, month - 1, day);
            dates.push(date);
          } else {
            //console.log(`Invalid date format: ${dateString}`);
          }
        }

        for (let k = 0; k < fornecedor.length; k++) {
          if (fornecedor[k]) {
            const date = dates.length > 1 ? dates[k] : dates[0];
            janelaData[k] = date;
            // passos = passos + 1;
            // //console.log("janela " + k);
            // console.log(janelaData[k]);
          }
        }

        for (let i = 0; i < janelas.length; i++) {
          const horasMinutos = janelas[i];
          const dataFinal = new Date(janelaData[i]);
          if (horasMinutos !== null && horasMinutos !== undefined && horasMinutos !== '') {
            const [horas, minutos] = horasMinutos.split(':');
            dataFinal.setHours(dataFinal.getHours() + parseInt(horas, 10));
            dataFinal.setMinutes(dataFinal.getMinutes() + parseInt(minutos, 10));
            janelaData[i] = dataFinal;
            passos = passos + 1;
            // //console.log('dataFinal')
            // //console.log(dataFinal)
          }
        }
      } else {
        //console.log('Invalid dataColeta:', dataColeta);
      }

      if (typeof dataDestino !== 'string') {
        const jsDate = this.excelDateToJsDate(dataDestino);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const formattedDate = `${day}/${month}/${year}`;
        dataDestino = formattedDate
      }


      if (typeof dataDestino === 'string') {
        const dateStrings: string[] = dataDestino.includes('|') ? dataDestino.split('|') : [dataDestino];

        const datesDestino: Date[] = [];

        for (const dateString of dateStrings) {
          const parts: string[] = dateString.split('/');
          if (parts.length === 3) {
            const day: number = parseInt(parts[0], 10);
            const month: number = parseInt(parts[1], 10);
            const year: number = parseInt(parts[2], 10);

            const dateDestino: Date = new Date(year, month - 1, day);
            datesDestino.push(dateDestino);
          } else {
            //console.log(`Invalid date format: ${dateString}`);
          }
        }

        for (let l = 0; l < fornecedor.length; l++) {
          if (fornecedor[l]) {
            const date = datesDestino.length > 1 ? datesDestino[l] : datesDestino[0];
            janelaDestinoData[l] = date;
            // passos = passos + 1;        
          }
        }

        // for (let m = 0; m < janeladestino.length; m++) {
        //   const horasMinutos = janeladestino[m];
        //   console.log(janeladestino[m])
        //   const dataFinal = new Date(janelaDestinoData[m]);
        //   console.log(dataFinal)
        //   if (horasMinutos !== null && horasMinutos !== undefined && horasMinutos !== '') {
        //     const [horas, minutos] = horasMinutos.split(':');
        //     dataFinal.setHours(dataFinal.getHours() + parseInt(horas, 10));
        //     dataFinal.setMinutes(dataFinal.getMinutes() + parseInt(minutos, 10));
        //     janelaDestinoData[m] = dataFinal;
        //     passos = passos + 1;
        //   }
        // }

        for (let m = 0; m < janeladestino.length; m++) {
          const horasMinutos = janeladestino[m];
          const dataFinal = new Date(janelaDestinoData[m]);
          if (horasMinutos !== null && horasMinutos !== undefined && horasMinutos !== '') {
            const [horas, minutos] = horasMinutos.split(':');
            dataFinal.setHours(dataFinal.getHours() + parseInt(horas, 10));
            dataFinal.setMinutes(dataFinal.getMinutes() + parseInt(minutos, 10));
            const horaAtual = dataFinal.getHours();
            if (horaAtual < 6 || horaAtual > 12) {
              dataFinal.setHours(6, 0, 0, 0);
            }
            janelaDestinoData[m] = dataFinal;
            passos = passos + 1;
          }
        }
      }
      else {
        //console.log('Invalid dataDestino:', dataDestino);
      }
      // console.log(janelaData)
      const dateColeta1 = new Date(janelaData[0]);
      const janela1 = janelaData[0] ? format(dateColeta1, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateColeta2 = new Date(janelaData[1]);
      const janela2 = janelaData[1] ? format(dateColeta2, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateColeta3 = new Date(janelaData[2]);
      const janela3 = janelaData[2] ? format(dateColeta3, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateColeta4 = new Date(janelaData[3]);
      const janela4 = janelaData[3] ? format(dateColeta4, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateDestino1 = new Date(janelaDestinoData[0]);
      const janelaDestino1 = janelaDestinoData[0] ? format(dateDestino1, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateDestino2 = new Date(janelaDestinoData[1]);
      const janelaDestino2 = janelaDestinoData[1] ? format(dateDestino2, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateDestino3 = new Date(janelaDestinoData[2]);
      const janelaDestino3 = janelaDestinoData[2] ? format(dateDestino3, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;
      const dateDestino4 = new Date(janelaDestinoData[3]);
      const janelaDestino4 = janelaDestinoData[3] ? format(dateDestino4, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'") : null;

      // const dataFormatada = format(janelaData[0], "dd/MM/yyyy HH:mm");
      const inflatedItem: any = {
        'tableName': this.query,
        'ID': (Date.now() + i).toString(),
        'description': item[3],
        'Passos': passos,
        'Plate': item[14],
        // 'date': dataFormatada,
        'date': new Date(),
        'Janela 1': janela1, // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Janela 2': janela2, // Atribui o segundo valor do array resultante a 'Janela 2'
        'Janela 3': janela3, // Atribui o terceiro valor do array resultante a 'Janela 3'
        'Janela 4': janela4, // Atribui o terceiro valor do array resultante a 'Janela 3'
        'Fornecedor 1': fornecedor[0], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Fornecedor 2': fornecedor[1], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Fornecedor 3': fornecedor[2], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Fornecedor 4': fornecedor[3], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Destino 1': destino[0], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Destino 2': destino[1], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Destino 3': destino[2], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Destino 4': destino[3], // Atribui o primeiro valor do array resultante a 'Janela 1'
        'dataDestino': item['16'],
        'JanelaDestino 1': janelaDestino1, // Atribui o primeiro valor do array resultante a 'Janela 1'
        'JanelaDestino 2': janelaDestino2, // Atribui o primeiro valor do array resultante a 'Janela 1'
        'JanelaDestino 3': janelaDestino3, // Atribui o primeiro valor do array resultante a 'Janela 1'
        'JanelaDestino 4': janelaDestino4, // Atribui o primeiro valor do array resultante a 'Janela 1'
        'Weight Loaded': item[10] ? item[10] : 0,
        'Cubage': item[12] ? item[12] : 0,
        'Volumes': item[11] ? item[11] : 0,
        'Transport Type': item[13] ? item[13] : "sem modelo",
        'Total Distance': item[8] ? item[8] : 0,
        'Total Cost': item[24] ? item[24] : 0
        // Adicione mais campos conforme necessário
      };
      return inflatedItem;
    });
  }

  async getVeiculosFromDynamoDB(): Promise<void> {
    try {
      const filtro = '';
      const response: any = await new Promise(async (resolve, reject) => {
        (await this.dynamodbService.getItems(this.query3, this.urlConsultaCompleta, filtro)).subscribe(
          (res: any) => resolve(res),
          (error: any) => reject(error)
        );
      });

      if (response.statusCode === 200) {
        try {
          const items = JSON.parse(response.body);
          if (Array.isArray(items)) {
            this.veiculos = items.map(item => ({ ...item, checked: false }));
            // this.cdr.detectChanges();
          } else {
            console.error('Invalid items data:', items);
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      } else {
        console.error('Invalid response:', response);
      }
    } catch (error) {
      console.error(error);
    }
  }

  sortBy(column: string) {
    if (this.sortColumn === column) {
      // Reverse the sort direction
      this.sortDirection *= -1;
    } else {
      // Set the new sort column and reset the sort direction
      this.sortColumn = column;
      this.sortDirection = 1;
    }

    // Sort the data array based on the selected column and direction
    this.jsonData.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const valueA = a[this.sortColumn];
      const valueB = b[this.sortColumn];

      if (valueA < valueB) {
        return -1 * this.sortDirection;
      } else if (valueA > valueB) {
        return 1 * this.sortDirection;
      } else {
        return 0;
      }
    });
  }

}
